import React, { type ReactElement, useEffect } from 'react'
import { Skeleton, Typography, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { ReactComponent as LeftArrow } from 'assets/arrowLeft.svg'
import { useNavigate, useLocation } from 'react-router'
import { StoreStatus } from 'common/utils/types'

import { getProposalInfo } from '../bid.service'

import TenderDetails from './components/TenderDetails'
import ProposalDetails from './components/proposal-details/ProposalDetails'
import styles from './ProposalPage.module.scss'

const ProposalPage: React.FC = (): ReactElement => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { palette } = useTheme()
  const { tenderId } = useParams()
  const { proposal, getProposalInfoStatus, proposalTenderStatus } = useAppSelector((state) => state.bid)

  const goBack = (): void => {
    if (location.state?.from) {
      navigate(location.state.from)
    } else {
      navigate(-1)
    }
  }

  useEffect(() => {
    if (tenderId) {
      void dispatch(getProposalInfo({ tenderId }))
    }
  }, [tenderId])

  if (proposalTenderStatus === StoreStatus.Loading || getProposalInfoStatus === StoreStatus.Loading) {
    return (
      <div className={styles.loader}>
        <Skeleton
          height={400}
          width="100%"
          variant="rounded"
          sx={{ backgroundColor: palette.blue600.main }}
        />
        <Skeleton
          height={400}
          width="100%"
          variant="rounded"
          sx={{ backgroundColor: palette.blue600.main }}
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={goBack}>
        <LeftArrow />
        <Typography variant="subtitle1">Nazad</Typography>
      </div>
      {proposalTenderStatus === StoreStatus.Failed || getProposalInfoStatus === StoreStatus.Failed ? (
        <div className={styles.emptyState}>
          <Typography>Greška pri učitavanju podataka.</Typography>
        </div>
      ) : (
        <>
          {proposal?.tender?.id === tenderId && (
            <>
              <TenderDetails />
              <ProposalDetails />
            </>
          )}
          {proposal?.tender?.id !== tenderId && (
            <div className={styles.emptyState}>
              <Typography>Nema podataka</Typography>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ProposalPage
